import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Route } from 'vue-router';

/**
 * Don't use this component directly, use it by inheritance mechanism
 */
@Component({})
export default class PreviousRoute extends Vue {

    protected previousRoute: Route;

    public beforeRouteEnter(to, from, next) {

        // Gets called before the navigation will continue.
        next((vm: this) => {
            vm.previousRoute = from;
        });
    }
}
